<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="container">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div class="page-title sub">{{ $t('new.text1') }}</div>
      </div>
      <RuleBtn type="5" />
      <div class="detail-box" v-if="info">
        <template>
          <div class="marquee-box">
            <marquee
              id="affiche"
              align="left"
              behavior="scroll"
              direction="left"
              height="20"
              width="100%"
              vspace="10"
              loop="-1"
              scrollamount="5"
              scrolldelay="10"
              on-mouse-out="this.start()"
              on-mouse-over="this.stop()">
              {{ info && info.top_bar }}
            </marquee>
          </div>
          <div class="switch-box">
            <div
              class="item"
              :class="index + 1 === info.no ? 'active' : ''"
              v-for="(item, index) in switchList"
              :key="index">
              <div class="label">{{ item.label }}</div>
              <div class="val">{{ item.val }}</div>
            </div>
          </div>
          <div class="card-box">
            <div class="card-title">{{ $t('new.text2') }}</div>
            <div class="card-img"><img src="" /></div>
            <div class="card-content">
              {{ info.title }}
            </div>
          </div>
          <div class="title4">{{ $t('new.text3') }}</div>
          <div class="choose-box">
            <div
              class="item"
              :class="
                item.successed ? 'success' : item.selected ? 'active' : ''
              "
              v-for="(item, index) in info.options"
              @click="handleChoose(item)"
              :key="index">
              {{ index + 1 }}.
              {{ item.option }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="footer" v-if="info && !answered">
      <el-button
        type="primary"
        @click="handleConfirm"
        class="block el-button--special"
        >{{ $t('new.text4') }}</el-button
      >
    </div>
    <div class="open-area" style="height: 0.7rem" v-if="!answered"></div>
    <div class="footer" v-if="answered">
      <div class="result-box ac" style="margin-top: 0.2rem">
        <div
          style="text-align: center; font-size: 0.24rem; margin-bottom: 0.2rem">
          <span v-if="answered === 'success'">🎉🎉🎉</span>
          <span v-if="answered === 'fail'">💔💔💔</span>
        </div>
        <div class="h hh">
          <span v-if="answered === 'success'">{{ $t('congratulations') }}</span>
          <span v-else>{{ $t('new.text5') }}</span>
        </div>
        <div
          class="dis"
          v-if="rewardToken"
          v-html="$t('new.text6', { rewardToken: rewardToken })"></div>
        <div class="de" style="margin: 0.4rem 0 0.1rem" v-if="info.no === 3">
          {{ $t('new.text7') }}
          <el-button
            type="primary"
            size="mini"
            @click="handleBack"
            class="el-button--white">
            {{ $t('add.text50') }}</el-button
          >
        </div>
        <el-button
          v-else
          type="primary"
          size="mini"
          style="margin-top: 0.55rem"
          @click="handleNext"
          class="el-button--white"
          >{{ $t('new.text8') }}</el-button
        >
      </div>
    </div>
    <div class="open-area" style="height: 2.4rem" v-if="answered"></div>
  </div>
</template>
<script>
import RuleBtn from '@/components/RuleBtn.vue'

export default {
  props: {
    from: {
      type: String,
      default: () => 'user'
    },
    postQuestionGet: {
      type: Function,
      default: () => {}
    },
    postQuestionSubmit: {
      type: Function,
      default: () => {}
    }
  },
  components: { RuleBtn },
  data() {
    return {
      answered: null,
      popupVisible: true,
      info: null,
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      switchList: [
        {
          label: 'Quiz 1'
        },
        {
          label: 'Quiz 2'
        },
        {
          label: 'Quiz 3'
        }
      ],
      answer: null,
      over: false,
      rewardToken: null
    }
  },
  created() {
    this.init()
  },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  methods: {
    init() {
      let that = this
      this.postQuestionGet().then((res) => {
        that.info = res.data
      })
    },
    handleConfirm() {
      if (!this.answer) {
        this.$toast({
          message: this.$t('new.text9')
        })
        return
      }
      let params = {
        id: this.info.question_id,
        answer: this.answer
      }
      this.postQuestionSubmit(params)
        .then((res) => {
          if (res.data) {
            this.info.options = this.info.options.map((e) => {
              if (e.option_id === res.data.correct_answer) {
                e.successed = true
              } else {
                e.successed = false
              }
              if (e.option_id === res.data.my_answer) {
                e.selected = true
              } else {
                e.selected = false
              }
              return e
            })
            this.rewardToken = res.data.reward_token
            if (res.data.is_right) {
              this.answered = 'success'
            } else {
              this.answered = 'fail'
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleBack() {
      this.$router.back()
    },
    handleChoose(item) {
      this.info.options = this.info.options.map((e) => {
        if (e.option_id === item.option_id) {
          this.answer = item.option_id
          e.selected = true
        } else {
          e.selected = false
        }
        return e
      })
      console.log(this.info.options)
    },
    handleNext() {
      this.answered = null
      this.init()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QuizeBox.vue